module.exports = __webpack_public_path__ + "5c114213/img/chevron-down-icon.5542f65c.svg";